import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { AppNavigation, isNavNoDestinationItem } from '../../../../types/navigation.types';
import { BaseComponent } from '../../../base/base.component';
import { NavigationItemComponent } from '../../../navigation/item/navigation-item.component';
import { SwiperModule } from '../../../swiper';
import { SwiperElementOptions } from '../../../swiper/swiper.types';
import { ButtonModule } from '../../../button';

@Component({
  selector: 'immo-header-navigation-desktop',
  imports: [
    CommonModule,
    SwiperModule,
    NavigationItemComponent,
    ButtonModule,
  ],
  templateUrl: './header-navigation-desktop.component.html',
  styleUrl: './header-navigation-desktop.component.css',
})
export class HeaderNavigationDesktopComponent extends BaseComponent {
  // -----------------------------------------------------------------------------------------------------
  // @ INPUTS
  // -----------------------------------------------------------------------------------------------------

  readonly navigation = input.required<AppNavigation, AppNavigation>({
    transform: (value: AppNavigation) => {
      return value
        .flatMap((item) => [item, ...(item.children ?? [])])
        .filter((item) => !isNavNoDestinationItem(item)) as AppNavigation;
    },
  });

  // -----------------------------------------------------------------------------------------------------
  // @ INSTANCE VARIABLES
  // -----------------------------------------------------------------------------------------------------

  protected readonly menuOptions: SwiperElementOptions = {
    navigation: { addIcons: false },
  };
}
